var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM13 13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H9.41421C8.52331 13 8.07714 11.9229 8.70711 11.2929L12 8L15.2929 11.2929C15.9229 11.9229 15.4767 13 14.5858 13H13Z",
    fill: "#9A9CB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloud);
export default __webpack_public_path__ + "static/media/ico-cloud.d5c8b5d69205074255c2ac6ef1e41297.svg";
export { ForwardRef as ReactComponent };